import { render, staticRenderFns } from "./accountSuccess.vue?vue&type=template&id=290fec8e&"
import script from "./accountSuccess.vue?vue&type=script&lang=js&"
export * from "./accountSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports